import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-pmt-receipt-basic',
  templateUrl: "./pmt-receipt-basic.component.html",
  styles: [
  ]
})
export class PmtReceiptBasicComponent implements OnInit {
  @Input() web_filing_id = "" ;
  @Input() nbr= "" ;
  constructor() { }

  ngOnInit(): void {
  }

}
